"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StubErrorService = void 0;

var ErrorService_1 = require("../ErrorService");
/** A blank error service that does nothing. */


var StubErrorService = /*#__PURE__*/function (_ErrorService_1$Error) {
  _inherits(StubErrorService, _ErrorService_1$Error);

  function StubErrorService() {
    _classCallCheck(this, StubErrorService);

    return _possibleConstructorReturn(this, _getPrototypeOf(StubErrorService).apply(this, arguments));
  }

  _createClass(StubErrorService, [{
    key: "getCurrentTransaction",
    value: function getCurrentTransaction() {
      return undefined;
    }
    /** {@inheritDoc ErrorService.clearUserContext} */

  }, {
    key: "clearUserContext",
    value: function clearUserContext() {}
    /** {@inheritDoc ErrorService.setContext} */

  }, {
    key: "setContext",
    value: function setContext() {}
    /** {@inheritDoc ErrorService.leaveBreadcrumb} */

  }, {
    key: "leaveBreadcrumb",
    value: function leaveBreadcrumb(message, level, data, category) {}
    /** {@inheritDoc ErrorService.reportError} */
    // eslint-disable-next-line node/handle-callback-err

  }, {
    key: "reportError",
    value: function reportError(error, context) {}
    /** {@inheritDoc ErrorService.setUserContext} */

  }, {
    key: "_setUserContext",
    value: function _setUserContext(user) {}
    /** {@inheritDoc ErrorService.sync} */

  }, {
    key: "sync",
    value: function sync() {
      return Promise.resolve();
    }
  }, {
    key: "_getStubSpan",
    value: function _getStubSpan() {
      return {
        data: {},
        tags: {},
        name: 'stub',
        spanId: 'stub',
        startTimestamp: 0,
        traceId: 'stub',
        finish: function finish() {},
        setData: function setData() {
          return this;
        },
        setName: function setName() {
          return this;
        },
        setStatus: function setStatus() {
          return this;
        },
        setTag: function setTag() {
          return this;
        },
        updateWithContext: function updateWithContext() {
          return this;
        },
        setContext: function setContext() {
          return this;
        },
        setMeasurement: function setMeasurement() {
          return this;
        },
        startChild: function startChild() {
          return this;
        }
      };
    }
    /** {@inheritDoc ErrorService.span} */

  }, {
    key: "span",
    value: function span(opts, callback) {
      return callback(this._getStubSpan());
    }
    /** {@inheritDoc ErrorService.startSpan} */

  }, {
    key: "startSpan",
    value: function startSpan(opts) {
      return this._getStubSpan();
    }
    /** {@inheritDoc ErrorService.startTransaction} */

  }, {
    key: "_startTransaction",
    value: function _startTransaction(opts) {
      return this._getStubSpan();
    }
  }]);

  return StubErrorService;
}(ErrorService_1.ErrorService);

exports.StubErrorService = StubErrorService;